import Vue from 'vue'

let baasUrl = '/apiv1/area'

/**
 * 查询子节点
 */
export const getChildren = (params) => {
  return Vue.fetch.post(`${baasUrl}/query/children`, params)
}

/**
 * 查询所有的子节点
 */
export const getAllChildren = (params) => {
  return Vue.fetch.post(`${baasUrl}/query/allChildren`, params)
}

/**
 * 添加区域
 */
export const add = (params) => {
  return Vue.fetch.post(`${baasUrl}/add`, params)
}
/**
 * 更新区域
 */
export const update = (params) => {
  return Vue.fetch.post(`${baasUrl}/update`, params)
}

/**
 * 删除区域
 */
export const remove = (params) => {
  return Vue.fetch.post(`${baasUrl}/remove`, params)
}
/**
 * 删除区域下的人员
 */
export const removeUserFromArea = (params) => {
  return Vue.fetch.post(`${baasUrl}/user/remove`, params)
}

/**
 * 添加区域下的人员
 */
export const addUserFromArea = (params) => {
  return Vue.fetch.post(`${baasUrl}/user/add`, params)
}



// WEBPACK FOOTER //
// ./src/cdpBase/services/area.js